export default __webpack_public_path__ + "static/manUnt-b1673d7ad61c95f61b37f949f03054ed.png";